// extracted by mini-css-extract-plugin
export default {"adminProfileImg":"AdminProfileEdit_adminProfileImg__TysWF"};